module.exports = __webpack_public_path__ + "media/images/account/icon5-45a34a7fedf3cec343815c493884157a.svg";